"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var TimerMetric = /** @class */ (function () {
    /**
     * Constructor of the TimerMetric class.
     *
     * @param {string} name
     * @param {IEvent} parentEvent - optional.
     * @returns {ITimerMetric}
     */
    function TimerMetric(name, parentEvent) {
        this.name = name;
        this.parentEvent = parentEvent;
        this.startTime = 0;
        this.totalTime = 0;
    }
    /**
     * Stops and records the timer in the parent event by calling the
     * incrementTimer method.
     * @returns {ITimerMetric}
     */
    TimerMetric.prototype.recordTimer = function () {
        this.stopTimer();
        if (this.parentEvent) {
            this.parentEvent.removeTimer(this.name);
            this.parentEvent.addTimer(this.name, this.totalTime);
            this.totalTime = 0;
        }
        else {
            console.error('Could not log this metric as no parent event is defined.');
        }
        return this;
    };
    /**
     * Stops and records the timer in the events that are passed by calling the
     * incrementTimer method.
     * @param {IEvent} events
     */
    TimerMetric.prototype.recordTimerInEvents = function () {
        var _this = this;
        var events = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            events[_i] = arguments[_i];
        }
        this.stopTimer();
        events.forEach(function (event) {
            event.removeTimer(_this.name);
            event.addTimer(_this.name, _this.totalTime);
        });
    };
    /**
     * Starts the timer if not already started.
     */
    TimerMetric.prototype.startTimer = function () {
        if (this.startTime === 0) {
            this.startTime = Date.now();
        }
    };
    /**
     * Stops the timer if started. This method does not record the timer as
     * developer would like to start the timer again.
     *
     * Will change it to end and record if needed.
     * @returns {ITimerMetric}
     */
    TimerMetric.prototype.stopTimer = function () {
        if (this.startTime > 0) {
            this.totalTime += Date.now() - this.startTime;
            this.startTime = 0;
        }
        else {
            console.error('Trying to stop a timer without starting it.');
        }
        return this;
    };
    return TimerMetric;
}());
exports.TimerMetric = TimerMetric;
//# sourceMappingURL=timer-metric.js.map